import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { useIntl } from 'react-intl-next';
import TextArea from '@atlaskit/textarea';
import { messages } from './messages';
export const EditOtherOption = ({
  dropdown,
  isDisabled,
  value,
  onChange
}) => {
  const intl = useIntl();
  const TextWrapper = dropdown ? OptionalTextWrapperDropdown : OptionalTextWrapper;
  return /*#__PURE__*/React.createElement(TextWrapper, null, /*#__PURE__*/React.createElement(TextArea, {
    appearance: "standard",
    isCompact: false,
    placeholder: intl.formatMessage(messages.choiceDropdownNewOption),
    isDisabled: isDisabled,
    isReadOnly: false,
    minimumRows: 2,
    maxHeight: "none",
    isMonospaced: false,
    value: value,
    resize: "smart",
    spellCheck: false,
    theme: undefined,
    onBlur: undefined,
    onChange: event => {
      onChange ? onChange(event) : undefined;
    },
    onFocus: undefined
  }));
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const OptionalTextWrapper = styled.div({
  marginLeft: "var(--ds-space-300, 24px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const OptionalTextWrapperDropdown = styled.div({
  marginTop: "var(--ds-space-050, 4px)"
});